module.exports = __webpack_public_path__ + "static/media/browser-opera.c20249e4.svg";